module.exports = __webpack_public_path__ + "static/media/video.fd947463.svg";